// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"607403b4","401":"b271193e","453":"f6c94965","455":"d215164c","503":"089d3f37","602":"f2f04803","977":"82141ca8","991":"bbff65a3","999":"aa73bb28"}[chunkId] + ".chunk.js";
};